const state = {
  departmentParams: [],
  locationParams: [],
  pageParam: 1,
  searchParam: '',
  teamParams: [],
}

const getters = {
  getDepartmentParams: state => {
    return state.departmentParams
  },
  getLocationParams: state => {
    return state.locationParams
  },
  getPageParam: state => {
    return state.pageParam
  },
  getSearchParam: state => {
    return state.searchParam
  },
  getTeamParams: state => {
    return state.teamParams
  },
}

const mutations = {
  addLocation (state, location) {
    const { locationParams } = state
    if (!locationParams.includes(location)) {
      state.locationParams.push(encodeURIComponent(location))
    }
  },
  addDepartment (state, department) {
    const { departmentParams } = state
    if (!departmentParams.includes(department)) {
      state.departmentParams.push(encodeURIComponent(department))
    }
  },
  addTeam (state, team) {
    const { teamParams } = state
    if (!teamParams.includes(team)) {
      state.teamParams.push(encodeURIComponent(team))
    }
  },
  clearSearch (state) {
    state.searchParam = ''
  },
  removeDepartment (state, department) {
    const { departmentParams } = state
    state.departmentParams.splice(departmentParams.indexOf(encodeURIComponent(department)), 1)
  },
  removeLocation (state, location) {
    const { locationParams } = state
    state.locationParams.splice(locationParams.indexOf(encodeURIComponent(location)), 1)
  },
  removeTeam (state, team) {
    const { teamParams } = state
    state.teamParams.splice(teamParams.indexOf(encodeURIComponent(team)), 1)
  },
  reset (state) {
    state.departmentParams = []
    state.locationParams = []
    state.searchParam = ''
    state.teamParams = []
  },
  setKeywordSearch (state, search) {
    state.searchParam = search
  },
  setPage (state, page) {
    state.pageParam = page
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
